import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentLeftBar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAlignmentLeftBar"><Path d="M2.5 4.5V19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 6.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 12H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 17.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAlignmentLeftBar;
